module.exports = __webpack_public_path__ + "img/evaluateImg01.6ea76472.png";